import React from 'react';
import _ from 'lodash';
import { getTeamUrl } from '../utils/routes';
import { useTeamLogos } from '../hooks/team';
import { getProxyUrl } from '../utils/image';

export default function HeaderTeamLogo({ teams }) {
  const [teamLogos] = useTeamLogos();

  const getTeamLogo = (abbrv) => {
    const team = teamLogos.find((x) => x.abbrv === abbrv);

    const url = getProxyUrl(team?.logo || team?.logoImageUrl, 300, 300);
    return url;
  };

  if (teamLogos && teams) {
    const sortedTeams = _.sortBy(teams, [team => team.name.toLowerCase()], 'desc');
    return (
      <div className="team-bar">
        <div className="site-container team-bar__container">
          {sortedTeams?.map((t) => {
            return (
              <a
                key={t.abbrv}
                className="team-bar__item"
                href={getTeamUrl(t.abbrv)}
              >
                <img key={t.abbrv} src={getTeamLogo(t.abbrv)} alt={t.name} />
              </a>
            );
          })}
        </div>
      </div>
    );
  }

  return null;
}
